import { render } from "./contact-message-modal.vue?vue&type=template&id=74249ff0"
import script from "./contact-message-modal.vue?vue&type=script&lang=js"
export * from "./contact-message-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__